#import "../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query TransactionCommonData {
  invoiceTransactionTypes(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      transactionType
      layoutType
    }
  }
  companyCurrencies(orderBy: ISO_CODE_ASC) {
    nodes {
      id
      isoCode
      name
    }
  }

  companyBusinessUnits {
    nodes {
      id
      name
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
    }
  }
  tax1099T4Types {
    nodes {
      id
      tax1099T4Type
    }
  }
  productionIncentives {
    nodes {
      id
      incentiveType {
        incentiveType
      }
    }
  }
  invoiceDistributionStatusTypes {
    nodes {
      id
      statusType
      isExplanationRequired
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  invoiceStatusTypes {
    nodes {
      id
      statusType
    }
  }
  companies(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyCorporatePeriods(
    filter: { isEntryAllowed: { equalTo: true } }
    orderBy: [IS_ENTRY_ALLOWED_DESC, START_DATE_ASC]
  ) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }

  companyCardHolders {
    nodes {
      id
      cardFullName
      cardNumber
      departmentId
    }
  }

  invoiceUsers {
    nodes {
      userId
      userName
    }
  }
}
